/*
    BusRoom BUS On a Bus
    Pic bus
    Hints 2000
    InformOnEntry You are riding on a bus, on your way to visit that famous scientist and adventurer, your own Uncle Julius.
    RoomScriptBox VIEWNOTE 224 248 121 62 NOTE
    GoBox DOOR 281 0 50 192 HOMEGATE Right
    RoomScriptBox HIDENOTE 36 24 440 272 NOTE Glasses
    HitDisable VIEWNOTE
    HitDisable DOOR

    'Greetings!\n\nI just got off the phone with you-know-who, and they say you ',
    'can come and spend a couple of weeks at my house whenever you like. I hope ',
    'it will be soon - I''m in the middle of some \brather interesting experiments\r ',
    'that I''m sure you won''t want to miss! The bus from the train station will ',
    'bring you right past my door... the driver will tell you when to get off. ',
    'See you soon, I hope.\n\n',
    '        Love,\n\n                U.J.'
*/

function BusRideRoom(game) {

    this.Room_constructor(game, 'busride');
}

createjs.extend(BusRideRoom, Room);

BusRideRoom.prototype.preload =
    function () {
        this.manifest =
            this.makeManifest(this.id, [
                '#scene', 'window-frames', 'door-overlay', 'envelope', 'wiper-frames',
                {full_id: 'sound-ahhh', full_src: 'sounds/ahhh.wav'},
                {full_id: 'sound-bus-run', full_src: 'sounds/busride-run.wav'},
                {full_id: 'sound-bus-stop', full_src: 'sounds/busride-stop.wav'}
            ]);

        this.Room_preload(this.manifest);
    };

BusRideRoom.prototype.load =
    function () {
        this.Room_load();

        /* Audio */
        this.sndAhhh = this.world.queue.getResult('sound-ahhh');
        this.sndBusRun = this.world.queue.getResult('sound-bus-run');
        this.sndBusStop = this.world.queue.getResult('sound-bus-stop');

        /* Animation: exterior through bus window */
        this.loadWindow();

        /* Overlay for door when open */
        this.loadDoor();

        /* Envelope on seat containing letter from UJ */
        this.loadEnvelope();

        /* Animation: windshield wipers */
        this.loadWiper();

        /* Driver's speech balloon */
        this.loadBalloon();

        /* Letter open and on display */
        this.loadLetter();

        return this;
    };

BusRideRoom.prototype.enter =
    function () {
        this.Room_enter(
            'You are riding on a bus, on your way to visit that famous scientist and adventurer, your own Uncle Julius.'
        );

        if (!this.data('busStopped')) {
            /* Store the sound instance so that it can be stopped when the bus slows down */
            this.sinsBusRun = createjs.Sound.play('sound-bus-run', {loop: -1, volume: 0.2});
        }

        return this;
    };

BusRideRoom.prototype.leave =
    function () {
        this.animWindow.stop();
        this.animWiper.stop();

        this.Room_leave();
    };

BusRideRoom.prototype.next =
    function () {
        return new HomeGateRoom(this.world);
    };

BusRideRoom.prototype.startStoppingBus =
    function () {
        if (!this.data('busStopped'))
            createjs.Tween.get(this.conSpeech).to({}, 2500).to({alpha: 1}, 500).call(this.stopBus, {}, this);
    };

BusRideRoom.prototype.stopBus =
    function () {
        this.animWindow.stop();
        this.animWiper.stop();
        this.sinsBusRun.stop();
        createjs.Sound.play('sound-bus-stop', {volume: 0.2});
        this.artDoorOverlay.visible = true;
        this.data('busStopped', true);
    };

BusRideRoom.prototype.loadBalloon =
    function () {
        this.speechDriver = new createjs.Text('The Uncle Julius residence!', this.world.fonts.speech, this.world.pens.txSpeech);
        this.conSpeech = this.speechBalloon({x: 54, y: 7, w: 200, h: 60}, this.speechDriver);
        this.conSpeech.alpha = this.data('busStopped') ? 1 : 0;
        this.reg(this.conSpeech);
    };

BusRideRoom.prototype.loadDoor =
    function () {
        this.artDoorOverlay = ujPut(new createjs.Bitmap(this.world.queue.getResult('busride-door-overlay')), 281, 0, 'door');
        this.artDoorOverlay.visible = this.data('busStopped');
        this.artDoorOverlay.gameCursor = 'right';
        this.artDoorOverlay.on('click', this.leave, this);
        this.reg(this.artDoorOverlay);
    };

BusRideRoom.prototype.loadEnvelope =
    function () {
        this.artEnvelope = ujPut(new createjs.Bitmap(this.world.queue.getResult('busride-envelope')), 216, 242, 'envelope');
        this.artEnvelope.gameCursor = 'examine';

        this.artEnvelope.on('click', function (mouseData) {
            this.data('letterOpen', true);

            createjs.Tween.get(this.conLetter, {override: true})
                .to({alpha: 1}, 750)
                .call(this.resetCursor, {}, this);

            var ahhh = createjs.Sound.play('sound-ahhh');
            ahhh.volume = 0.2;
        }, this);

        this.reg(this.artEnvelope);
    };

BusRideRoom.prototype.loadLetter =
    function () {
        this.artLetter = new createjs.Shape();
        this.artLetter.graphics.beginFill(this.world.pens.bgLetter).drawRect(36, 24, 440, 272);
        //this.artLetter.gameCursor = 'out';

        this.subloadLetterText();
        //this.textLetter.gameCursor = 'out';
        this.conLetter = new createjs.Container();
        this.conLetter.addChild(this.artLetter);
        this.conLetter.addChild(this.textLetter);

        this.setContainerCursor(this.conLetter, 'out');

        this.conLetter.on('click', function (mouseData) {
            this.data('letterOpen', false);

            createjs.Tween.get(this.conLetter)
                .to({alpha: 0}, 750)
                .call(this.resetCursor, {}, this)
                .to({}, 3500)
                .call(this.startStoppingBus, {}, this);
        }, this);

        this.reg(this.conLetter);
    };

BusRideRoom.prototype.loadWindow =
    function () {
        var busWindowAnimData = {
            images: [this.world.queue.getResult('busride-window-frames')],
            frames: {width: 479, height: 112, count: 4},
            animations: {
                run: {frames: [0, 1, 2, 3], next: 'run', speed: 0.2},
                stopped: 0
            }
        };

        this.artWindowFrames = new createjs.SpriteSheet(busWindowAnimData);
        this.animWindow = ujPut(new createjs.Sprite(this.artWindowFrames, this.data('busStopped') ? 'stopped' : 'run'), 35, 0, 'window');
        this.reg(this.animWindow);
    };

BusRideRoom.prototype.loadWiper =
    function () {
        var busWiperAnimData = {
            images: [this.world.queue.getResult('busride-wiper-frames')],
            frames: {width: 180, height: 105, count: 4},
            animations: {
                run: {frames: [0, 1, 2, 3], next: 'run', speed: 0.11},
                stopped: 0
            }
        };

        this.artWiperFrames = new createjs.SpriteSheet(busWiperAnimData);
        this.animWiper = ujPut(new createjs.Sprite(this.artWiperFrames, this.data('busStopped') ? 'stopped' : 'run'), 49, 0, 'wiper');
        this.reg(this.animWiper);
    };

BusRideRoom.prototype.subloadLetterText =
    function () {
        var letterData = [
            {text: 'Greetings!', x: 0, y: 0, pen: 0},
            {text: 'I just got off the phone with you-know-who, and they say you', x: 0, y: 28, pen: 0},
            {text: 'can come and spend a couple of weeks at my house whenever', x: 0, y: 48, pen: 0},
            {text: 'you like.  I hope it will be soon — I’m in the middle of some', x: 0, y: 68, pen: 0},
            {text: 'rather interesting experiments', x: 0, y: 88, pen: 1},
            {text: 'that I’m sure you won’t want to', x: 204, y: 88, pen: 0},
            {text: 'miss!  The bus from the train station will bring you right past', x: 0, y: 108, pen: 0},
            {text: 'my door... the driver will tell you when to get off.  See you', x: 0, y: 128, pen: 0},
            {text: 'soon, I hope.', x: 0, y: 148, pen: 0},
            {text: 'Love,', x: 30, y: 176, pen: 0},
            {text: 'U.J.', x: 45, y: 196, pen: 0}
        ];

        function font(fonts) {
            return fonts.letter;
        }

        function color(pens, pen) {
            return pens[pen ? 'txLetterHi' : 'txLetter'];
        }

        var letterText = new createjs.Container();

        for (var i = 0; i < letterData.length; i++) {
            var td = letterData[i];
            var text = ujPut(new createjs.Text(td.text, font(this.world.fonts), color(this.world.pens, td.pen)), td.x, td.y, 'line-' + i);

            letterText.addChild(text);
        }

        this.textLetter = ujPut(letterText, 46, 34, 'letter-text');
    };

createjs.promote(BusRideRoom, 'Room');
